<template>
  <ellipse class="can-grab" :class="{'is-grabbing': grabbing}"
          :cx="attr.cx" :cy="attr.cy" :rx="attr.rx" :ry="attr.ry"
          @touchstart="startDrag" @mousedown="startDrag"
          :style="{fill: attr.fill}"
          />
</template>

<script>
import DrawObject from '@/components/svg/DrawObject.js'

export default {
  mixins: [DrawObject],
  name: 'SEllipse',
  data () {
    return {
      xKey: 'cx',
      yKey: 'cy'
    }
  }
}
</script>
